<template>
  <DashboardLayout>
    <Breadcrumb class="flex breadcrumb" :model="items" />
    <div class="card flex flex-column pt-4 px-4">
      <div class="flex justify-content-between align-items-center mb-3">
        <span class="Subtitle-Medium">Pending Invitations</span>
      </div>

      <DataTable :value="pending" :paginator="true" :rows="10" :loading="loading" stripedRows>
        <Column field="username" header="Username" />
        <Column field="email" header="Email" />
        <Column header="Action">
          <template #body="{ data }">
            <Button label="Delete" class="yellow-button-small" @click="deleteInvite(data)" />
          </template>
        </Column>
      </DataTable>
    </div>
  </DashboardLayout>
</template>

<script setup>
import { ref, onMounted } from "vue";
import Breadcrumb from "primevue/breadcrumb";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Button from "primevue/button";
import DashboardLayout from "@/layout/DashboardLayout.vue";
import { getPendingTutors, deletePendingTutor } from "@/api/institutes";


const items = [{ label: "Dashboard" }, { label: "Our Tutors" }, { label: "Pending Invitations" }];
const pending = ref([]);
const loading = ref(false);

const fetchPending = async (page = 1, limit = 10) => {
  loading.value = true;
  try {
    const res = await getPendingTutors({ page, limit });
    pending.value = res.data.data?.tutors || [];
  } finally {
    loading.value = false;
  }
};

const deleteInvite = async (tutor) => {
  loading.value = true;
  try {
    await deletePendingTutor(tutor._id);
    pending.value = pending.value.filter((t) => t._id !== tutor._id);
  } finally {
    loading.value = false;
  }
};

onMounted(() => fetchPending());
</script>